import { matchPath } from 'react-router-dom';

import { useLocation } from './useLocation';

export const useMatchPath = (pathname: string) => {
    const location = useLocation();

    return !!matchPath(location.pathname, pathname);
};
